import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import { Accordion, AccordionPanel } from '@salesforce/design-system-react';
import PersonaIcons from './PersonaIcons';
import Products from './Products';

class OverlayColumn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedPanels: {
        productsPanel: true,
        herosPanel: true,
      },
    };
  }

  togglePanel = (id) => {
    this.setState({
      expandedPanels: {
        ...this.state.expandedPanels,
        [id]: !this.state.expandedPanels[id],
      },
    });
  };

  render() {
    return (
      <React.Fragment>
        <Accordion>
          <AccordionPanel
            id="productsPanel"
            summary="Salesforce Products and Solutions"
            title="Salesforce Products and Solutions"
            onTogglePanel={() => this.togglePanel('productsPanel')}
            expanded={!!this.state.expandedPanels['productsPanel']}
            className="accordion-panel"
          >
            <Droppable droppableId="droppable-product">
              {(provided, snapshot) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {provided.placeholder}
                  <Products products={this.props.products} />
                </div>
              )}
            </Droppable>
          </AccordionPanel>
          <AccordionPanel
            id="herosPanel"
            summary="Hero Story Personas"
            title="Hero Story Personas"
            onTogglePanel={() => this.togglePanel('herosPanel')}
            expanded={!!this.state.expandedPanels['herosPanel']}
          >
            <Droppable droppableId="droppable-persona">
              {(provided, snapshot) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {provided.placeholder}
                  <PersonaIcons personas={this.props.personas} />
                </div>
              )}
            </Droppable>
          </AccordionPanel>
        </Accordion>
      </React.Fragment>
    );
  }
}

OverlayColumn.propTypes = {
  products: PropTypes.object.isRequired,
  personas: PropTypes.object.isRequired,
};

export default OverlayColumn;
